// @tc-check
import noop from 'lodash/noop';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import SearchInput from 'components/SearchInput';
import AutoSizer from 'react-virtualized-auto-sizer';
import { ListItemRenderer } from './ListItemRenderer';
import { StyledList } from './ListItemRenderer.style';
import {
  StyledCustomMenuItem,
  StyledListContainer,
  StyledMenu
} from './Menu.style';

const Menu = ({
  options,
  selected = [],
  disabled = [],
  selectedPathIds = [],
  dataAttrName,
  menuWidth,
  menuWidthExpanded,
  level,
  multiple,
  isMaxLimit,
  isSearchMode,
  searchable = false,
  onOptionClick,
  onOpenMenuClick,
  onSearch,
  searchValue,
  searchPlaceholder,
  classes = {},
  openedParents = [],
  noSearchResultsAction,
  optionActions = [],
  handleCloseMenus = noop,
  handleClearSearch = noop,
  isDisableChildrenOfSelectedParent,
  isSubMenu
}) => {
  const noSearchResults = options.length === 0;

  const itemData = {
    options,
    selected,
    multiple,
    isDisableChildrenOfSelectedParent,
    disabled,
    isMaxLimit,
    openedParents,
    selectedPathIds,
    isSearchMode,
    dataAttrName,
    optionActions,
    classes,
    onOptionClick,
    onOpenMenuClick,
    handleCloseMenus,
    handleClearSearch
  };

  return (
    <StyledMenu
      id={`multiLevelMenu-${level}`}
      isSearchMode={isSearchMode}
      menuWidth={menuWidth}
      menuWidthExpanded={menuWidthExpanded}
    >
      {searchable && (
        <StyledCustomMenuItem
          onClick={event => {
            event.stopPropagation();
          }}
        >
          <SearchInput
            value={searchValue}
            placeholder={searchPlaceholder}
            autoFocus
            width='unset'
            height='3.1rem'
            onChange={value => onSearch(value)}
          />
          {isSearchMode && noSearchResults ? (
            <span>
              <Flex pt='normal'>
                <Text size='medium' data-testid='no-results'>
                  No results for <b>{searchValue}</b>
                </Text>
              </Flex>
              <Flex
                data-testid='no-results-action'
                onClick={event => {
                  event.stopPropagation();
                  handleClearSearch();
                }}
              >
                {noSearchResultsAction}
              </Flex>
            </span>
          ) : null}
        </StyledCustomMenuItem>
      )}
      <StyledListContainer isSubMenu={isSubMenu}>
        <AutoSizer>
          {({ width, height }) => (
            <StyledList
              itemData={itemData}
              height={height}
              width={width}
              itemCount={options.length}
              itemSize={56}
              overscanCount={5}
            >
              {ListItemRenderer}
            </StyledList>
          )}
        </AutoSizer>
      </StyledListContainer>
    </StyledMenu>
  );
};

export default Menu;
